


























































import ActionButton from '@/components/atoms/Button.vue'
import {
  NotificationAction,
  NotificationLevel,
} from '@/components/molecules/notification-section/model/notification-section-model'
import NotificationSectionWrapper from '@/components/molecules/notification-section/NotificationSectionWrapper.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

/**
 * 左にアイコン、右にタイトル + 本文 + アクションボタンを置く通知セクション。
 * 複数文にわたる長文を想定し、本文は p タグで段落分けされることを想定している。
 */
@Component({
  components: {
    ActionButton,
    NotificationSectionWrapper,
  },
})
export default class WithActionNotificationSection extends Vue {
  @Prop({ required: true })
  readonly level: NotificationLevel

  @Prop({ required: true })
  readonly title: string

  @Prop({ required: true })
  readonly action: NotificationAction | null
}
